// libraries
import { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { List, Tag, Typography } from 'antd';
import { red } from '@ant-design/colors';
import { CheckOutlined } from '@ant-design/icons';

import { txt } from '../../../../locales/i18n';
import { formatDate } from '../../../../utils/date';
import { SubscriptionTags, renderSubscription } from '../../../shared/subscriptions';

export function UserListContentMobile(props: any): JSX.Element {
	const [showSubscription, setShowSubscription] = useState(false);
	const navigateTimeout = useRef<NodeJS.Timeout | null>(null);

	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const subscription = searchParams.get('subscription');
		setShowSubscription(subscription !== null);
	}, [location.search]);

	useEffect(() => {
		if (navigateTimeout.current !== null) clearTimeout(navigateTimeout.current);

		const itemId = location.hash.replace('#', '');
		const itemSelector = `li#item-${itemId}`;
		const listItemElement = document.querySelector(itemSelector);

		if (listItemElement === null) return;

		navigateTimeout.current = setTimeout(() => {
			listItemElement.scrollIntoView({ behavior: 'auto', block: 'center' });
		}, 100);
	}, [props.dataSource, location.hash]);

	function renderUniverse(universe: string | null): JSX.Element | null {
		if (universe === null) return null;

		return (
			<Tag key={universe} color="blue">
				{universe.toUpperCase()}
			</Tag>
		);
	}

	function renderCheckmark(value: any): null | JSX.Element {
		if (Boolean(value) === false) return null;
		return <CheckOutlined />;
	}

	
	function renderGender(gender: number) {
		if (gender === 1) return txt('genders.male');
		if (gender === 2) return txt('genders.female');
		if (gender === 3) return txt('genders.other');
		return null;
	}

	function getHighlight(item: Record<string, any>): string | void {
		if (Boolean(item.banned) === true) return 'red';
	}

	function renderItem(item: Record<string, any>): JSX.Element {
		return (
			<>
				{showSubscription && <SubscriptionTags />}

				<StyledListItem
					highlight={getHighlight(item)}
					id={'item-' + item.id}
					onClick={() => {
						history.replace({ hash: String(item.id), search: location.search });
						history.push(`/users/${item.id}`);
					}}
				>
					<Typography.Text type="secondary">{txt('global.username')}</Typography.Text>
					<Typography.Text ellipsis>{item.username}</Typography.Text>

					<Typography.Text type="secondary">Email</Typography.Text>
					<Typography.Text ellipsis>{item.email}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.age')}</Typography.Text>
					<Typography.Text ellipsis>{item.age}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.gender')}</Typography.Text>
					<Typography.Text ellipsis>{renderGender(item.gender)}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.municipality')}</Typography.Text>
					<Typography.Text ellipsis>{item.municipality}</Typography.Text>

					<Typography.Text type="secondary">
						{txt('global.latest universe')}
					</Typography.Text>
					<Typography.Text ellipsis>{renderUniverse(item.universe)}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.posts')}</Typography.Text>
					<Typography.Text ellipsis>{item.posts || null}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.messages')}</Typography.Text>
					<Typography.Text ellipsis>{item.messages || null}</Typography.Text>

					<Typography.Text type="secondary">
						{txt('global.conversations')}
					</Typography.Text>
					<Typography.Text ellipsis>{item.conversations || null}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.created')}</Typography.Text>
					<Typography.Text ellipsis>{formatDate(item.created)}</Typography.Text>

					{/* {item.origin !== 'Boblberg' && (
						<>
							<Typography.Text type="secondary">{txt('global.origin')}</Typography.Text>
							<Typography.Text ellipsis>{item.origin}</Typography.Text>
						</>
					)} */}

					<Typography.Text type="secondary">App</Typography.Text>
					<Typography.Text ellipsis>{renderCheckmark(item.hasApp)}</Typography.Text>

					{showSubscription && (
						<>
							<Typography.Text type="secondary">
								{txt('global.subscription')}
							</Typography.Text>
							<Typography.Text ellipsis>
								{renderSubscription(item?.currentSubscription)}
							</Typography.Text>
						</>
					)}
				</StyledListItem>
			</>
		);
	}

	return (
		<List
			size="large"
			itemLayout="vertical"
			loading={props.loading}
			renderItem={renderItem}
			dataSource={props.dataSource}
		/>
	);
}

const StyledListItem = styled<any>(List.Item)`
	display: grid;
	grid-template-columns: auto 1fr;
	gap: 0ch 1ch;
	border-left: 3px solid blue;

	background: ${({ highlight }) => {
		if (highlight === 'red') return `${red[0]};`;
		return 'none';
	}};

	border-left: ${({ highlight }) => {
		if (highlight === 'red') return `3px solid ${red[4]};`;
		return '3px solid transparent;';
	}};
`;
